<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import useUiStore from '../../stores/ui';
import useReaderStore from '../../stores/reader';
import useRenditionStore from '../../stores/rendition';

const { isControlsVisible, isPageRangeEditing, bottomBarHeight } = storeToRefs(useUiStore());
const dynamicBottomBarHeight = computed(() => `${bottomBarHeight.value}px`);
const { isFrogBook, isScrolledBook } = storeToRefs(useReaderStore());
const { isRenditionInitialized } = storeToRefs(useRenditionStore());

const shouldShowThumb = computed(
  () =>
    (isControlsVisible.value || isPageRangeEditing.value) &&
    isRenditionInitialized.value &&
    !isFrogBook.value &&
    !isScrolledBook.value,
);
</script>

<template>
  <v-fade-transition>
    <div v-if="shouldShowThumb" class="progress-thumb-overlay position-fixed d-flex justify-center align-center ma-2">
      <div class="overlay-inner d-flex flex-column align-center">
        <v-sheet
          v-if="!isPageRangeEditing"
          class="rounded-pill px-4 d-inline-flex align-center justify-center"
          height="48"
        >
          <slot />
        </v-sheet>
        <slot v-else />
      </div>
    </div>
  </v-fade-transition>
</template>

<style scoped lang="scss">
.progress-thumb-overlay {
  bottom: v-bind('dynamicBottomBarHeight');
  left: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);

  .overlay-inner {
    pointer-events: auto;
  }

  .v-sheet {
    background-color: rgb(var(--v-theme-inverse-surface), 0.9);
    color: rgb(var(--v-theme-surface));
    border: 1px solid rgb(var(--v-theme-outline-variant));
    outline: solid 1px rgb(var(--v-theme-outline-variant)) !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    max-width: 100%;
  }
}
</style>
